import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormControl, ReactiveFormsModule } from '@angular/forms';
import {
  MatFormFieldAppearance,
  MatLabel,
  MatFormField,
  MatError,
} from '@angular/material/form-field';
import { noop } from 'rxjs';
import { MatInput } from '@angular/material/input';
import { TranslatePipe } from '@speedy/core';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-speedy-textarea',
  templateUrl: './speedy-textarea.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SpeedyTextareaComponent),
    },
  ],
  standalone: true,
  imports: [
    MatLabel,
    MatFormField,
    MatInput,
    ReactiveFormsModule,
    MatError,
    TranslatePipe,
    AsyncPipe,
  ],
})
export class SpeedyTextareaComponent {
  /** Flag to set disabled state */
  @Input() set disabled(value: boolean) {
    if (value) {
      this.control.disable();
    }
  }
  /** Flag to set name */
  @Input() name!: string;

  /** Flag to set rows */
  @Input() rows!: number;

  /** Flag to set label */
  @Input() label!: string;

  /** Flag to set placeholder */
  @Input() placeholder!: string;

  /** Flag to set field appearance */
  @Input() appearance: MatFormFieldAppearance = 'outline';

  /** Flag to set field font size */
  @Input() fontSize = 14;

  /** Flag to set is field required */
  @Input() required = false;

  /** Flag to set is field required */
  @Input() control = new FormControl();

  touched = false;

  writeValue(value: string | number) {
    if (value !== this.control.value) {
      this.control.setValue(value, { emitEvent: false });
    }
  }

  public onTouched: () => void = noop;
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  private onChange: (_: any) => void = noop;
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public propagateChange: () => void = noop;

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  onInputChange(value: string | number) {
    this.onChange(value);
  }
}
